import React from "react";
import { getPaymentAdapter } from "../PaymentAdapterRegistry";
import type { PaymentAdapterContext } from "../types";
import type { PaymentMethod, PaymentProvider } from "@/services/student/checkout/checkout.interfaces";

interface PaymentAdapterRendererProps extends PaymentAdapterContext {
  provider: PaymentProvider;
  method: PaymentMethod;
}

export const PaymentAdapterRenderer: React.FC<PaymentAdapterRendererProps> = ({
  provider,
  method,
  ...context
}) => {
  const adapter = getPaymentAdapter(provider, method);

  if (!adapter) {
    return (
      <div className="rounded-md border border bg-surface-subtle p-4 text-sm text-surface-foreground">
        Esta forma de pagamento ainda não está disponível. Escolha outra opção na lista.
      </div>
    );
  }

  return <>{adapter.render({ ...context, provider, method } as PaymentAdapterContext)}</>;
};
